import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContractType } from '../models/contract-type.model';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractTypeService {

  constructor(private httpClient: HttpClient) { }

  getContractTypes() : Observable<ContractType[]> {
    return this.httpClient.get<ContractType[]>('assets/components/contract-types/contract-types.json').pipe(
      map(data => data)
    );
  }
}
